import { graphql } from "~/gql";
export const GET_MATTER_SPECIFIC_RATES = graphql(/* GraphQL */ `
  query matterSpecificRates($matterId: Float!, $currencyCode: String!) {
    matterSpecificRates(matterId: $matterId, currencyCode: $currencyCode) {
      id
      type
      isLevelRate
      amount
      description
      feeEarner {
        id
      }
      feeEarnerLevel {
        id
        description
      }
      organisationalUnit {
        id
      }
    }
  }
`);
